import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './HowToUse.scss';

export default function HowToUse(props) {

   // console.log('props ', props);
   // let isMobIsipadIsPotrait = window.deviceBasedonBodyClass == 'ipadDesktopPortrait' || window.deviceBasedonBodyClass == 'mobilePortrait' || window.deviceBasedonBodyClass =='ipadPortrait'  || window.deviceBasedonBodyClass =='androidTabPortrait';;
let QRSupport = props.QRSupport;
   const howToUSEClick = (e) => {

      // console.log(e)
      if(e == undefined) return;
      // return;
      let howTouseBtn = window.UiUtils.domElement.howToUseBtn;
      // let howTousePopupContainer = document.querySelector('#howTousePopupContainer');
      let howTousePopup = window.UiUtils.domElement.howToUsePopup;
      howTouseBtn.classList.toggle('active');
      howTousePopup.classList.toggle('active');
      // howTouseBtn.classList.contains("active") ? howTouseBtn.classList.remove('active') : howTouseBtn.classList.add('active');
      // howTousePopup.classList.contains("active") ? howTousePopup.classList.remove('active') : howTousePopup.classList.add('active');
      // howTousePopupContainer.style.display = 'block';
      // howTousePopup.classList.add('active');
      
      if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('howToUSEClick');
      if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaLabel('howToUSEClick');
      
      // console.log('window.domElement ', howTousePopup, howTouseBtn)
   }

   const howToUSEClose = (e) => {
         if(e == undefined) return;

         let howTouseBtn = window.UiUtils.domElement.howToUseBtn;
         // let howTousePopupContainer = document.querySelector('#howTousePopupContainer');
         let howTousePopup = window.UiUtils.domElement.howToUsePopup;
         howTouseBtn.classList.remove('active');
         howTousePopup.classList.remove('active');

         if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaLabel('howToUSEClose');
         setTimeout(function(){
            if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('howToUSEClose');
         },100)
         
   }
   
   return (
      <>
         <button className='howToUseBtn' tabIndex="-1" data-tabindex={0} aria-label='How to use' role="button" onClick={howToUSEClick} onKeyUp={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClick();
               }}>
            <img  role="presentation" aria-hidden="true" className='icon' src='./images/spacer.png' />
            {props.ui.howToUSE ?? 'How to use' }
         </button>

         {ReactDOM.createPortal(<div className={(QRSupport && window.isipad) ? 'howToUsePopup ipdaLandscapTop50' : 'howToUsePopup'} role='dialog' >
            
            <div className='textContainer'>
               <h3 tabIndex="-1" data-tabindex={1} className='howToUseText'>{props.ui.howToUSE ?? 'How to use'}</h3>
               <div className='moveRotateZoomContainer'>
                  <div tabIndex="-1" data-tabindex={1} className='row move' >
                     <span className='text'>{props.ui.move ?? 'Move'}</span>
                     <img className='icon' src='./images/spacer.png' alt={props.ui.move ?? 'Move'} aria-label="by swiping with two fingers on touchscreen or by clicking the right mouse button" />
                  </div>
                  <div tabIndex="-1" data-tabindex={1} className='row rotate'>
                     <span className='text'>{props.ui.rotate ?? 'Rotate'}</span>
                     <img className='icon' src='./images/spacer.png' alt={props.ui.rotate ?? 'Rotate'}  aria-label="by making a circular motion with one finger on touchscreen or by clicking the left mouse button" />
                  </div>
                  <div tabIndex="-1" data-tabindex={1} className='row zoom'>
                     <span className='text'>{props.ui.zoom ?? 'Zoom'}</span>
                     <img className='icon' src='./images/spacer.png' alt={props.ui.zoom ?? 'Zoom'}  aria-label="by using two fingers to pinch and expand or by using the scroll wheel on the mouse" />
                  </div>
               </div>
               <button tabIndex="-1" data-tabindex={6} type='button' className='closePopup' aria-label="close how to use dialog" onClick={howToUSEClose} onKeyDown={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClose();
               }}><img className='icon' src='./images/spacer.png'  /></button>
               {(window.isMobIsipadIsPotrait) && <button type='button' className='returnTo3D'  onClick={howToUSEClick} onKeyDown={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClick();
               }}>{props.ui.returnTo3D ?? 'Return to 3D View'} <img className='icon' src='./images/spacer.png'  /></button>}
            </div>
         </div>, document.getElementById('howTousePopupContainer')
      )}
      </>
   );
}
